import {
  EnergyLabel,
  MortgageCalculationResult,
  MortgageType,
} from '~/types/Calculations';

export type CalculateMaxMortgageProps = {
  income: number;
  age: number;
  hasPartner: boolean;
  partnerIncome?: number;
  partnerAge?: number;
  loans?: number;
  studentDebt?: number;
  alimony?: number;
  useNhg?: boolean;
  energyLabel?: EnergyLabel;
};

const createQuery = (
  type?: MortgageType,
  periods?: number[],
  officeId?: string
) => {
  const query: Record<string, string> = {};

  if (type) query.type = type;
  if (periods?.length && periods.length > 0) query.period = periods.join(',');
  if (officeId) query.officeId = officeId;

  const queryString = Object.entries(query)
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join('&');

  return queryString ? `?${queryString}` : '';
};

export const calculate = async (
  form: CalculateMaxMortgageProps,
  signal?: AbortSignal,
  type?: MortgageType,
  periods?: number[],
  officeId?: string,
  nhgEnabled?: boolean,
  energyLabelsEnabled?: boolean
): Promise<MortgageCalculationResult> => {
  const query = createQuery(type, periods, officeId);
  const res = await fetch(
    `/hypotheek/maximale-hypotheek-berekenen/berekenen${query}`,
    {
      method: 'POST',
      signal: signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        applicant: {
          income: form.income,
          age: form.age,
        },
        partner: form.hasPartner
          ? {
              income: form.partnerIncome,
              age: form.partnerAge,
            }
          : null,
        monthlyAmountLoans: form.loans,
        monthlyAmountStudentDebt: form.studentDebt,
        monthlyAmountAlimony: form.alimony,
        useNhg: nhgEnabled ? form.useNhg : undefined,
        energyLabel: energyLabelsEnabled ? form.energyLabel : undefined,
      }),
    }
  );

  if (!res.ok) {
    throw new Error('Failed to fetch max mortgage calculation');
  }

  return res.json();
};
